import { MessageSquareText } from 'lucide-react';
import { useAuthStore } from '@shared/state';
import { useFeedbackPanelStore } from './feedbackPanelStore';

export function FeedbackButton() {
  const user = useAuthStore((s) => s.user);
  const openPanel = useFeedbackPanelStore((s) => s.openPanel);

  if (!user) return null;

  return (
    <button
      type="button"
      onClick={openPanel}
      className="fixed bottom-5 left-5 z-40 flex items-center gap-1.5 rounded-full border border-dark-border bg-dark-surface px-3 py-1.5 text-[11px] text-content-secondary font-body hover:text-content hover:border-indigo-500/50 transition-colors shadow-lg"
      aria-label="Open feedback panel"
    >
      <MessageSquareText size={12} className="text-indigo-400" />
      Feedback
    </button>
  );
}
